import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/modules/auth/context/AuthContext'
import { isMasterByEmail, normalizeRole } from '@/shared/utils/role'
import RewardsPage from './RewardsPage'

export default function RewardsEntryPage() {
  const { user, profile } = useAuth()
  const metaRole = normalizeRole(
    String((user as any)?.user_metadata?.role || (user as any)?.app_metadata?.role || '').trim(),
  )
  const isMaster = isMasterByEmail(user?.email) || profile?.role === 'master' || metaRole === 'master'

  if (isMaster) return <Navigate to="/rewards-master-dashboard" replace />
  return <RewardsPage />
}
